import angular from 'angular';

import component from './venue-hours-manage.component';

const VenueHoursManage = angular
    .module('control-room.venue-hours.components.venue-hours-manage', [])
    .component('crVenueHoursManage', component);

export default VenueHoursManage;
